import React, { useState, useLayoutEffect } from 'react'

import { Loader } from '@/components/Loader'
import { EventImageProps } from '@/types/componentsPropsTypes'

import { ImageBox } from './styles'

export const EventImage = ({ src, withCover }: EventImageProps) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isFailed, setIsFailed] = useState(false)

  useLayoutEffect(() => {
    setIsLoading(true)
    setIsFailed(false)
  }, [src])

  return (
    <ImageBox $withCover={withCover}>
      {isLoading && <Loader />}
      <img
        src={src}
        className={isLoading || isFailed ? '' : 'isVisible'}
        onLoad={() => {
          setIsLoading(false)
        }}
        onError={() => {
          setIsLoading(false)
          setIsFailed(true)
        }}
        alt=""
      />
    </ImageBox>
  )
}
